define('responsive-gameday/controllers/GamePanelStateViewController',['require','exports','module','Responsive/util/extend','Responsive/util/renderComplete','Responsive/util/dom','message-service/message-service','Responsive/controllers/ViewController','GameDayCore','gameday-index-url-hasher/enums/HashEvents','GameDayCore/GDUtil/dataMapping/GameStateUtil','GameDayCore/GDUtil/dataMapping/LocalizationUtil','./GamePanelViewController','../views/Monitor/Events/ViewModelUpdateEvents'],function(require,exports,module) {
    var extend = require("Responsive/util/extend"),
        renderComplete = require("Responsive/util/renderComplete"),
        dom = require("Responsive/util/dom"),
        MessageService = require("message-service/message-service"),
        ViewController = require("Responsive/controllers/ViewController"),
        GDC = require("GameDayCore"),
        HashEvents = require("gameday-index-url-hasher/enums/HashEvents"),
        GameStateUtil = require("GameDayCore/GDUtil/dataMapping/GameStateUtil"),
        LocalizationUtil = require("GameDayCore/GDUtil/dataMapping/LocalizationUtil"),
        GamePanelViewController = require("./GamePanelViewController"),
        UpdateEvents =  require("../views/Monitor/Events/ViewModelUpdateEvents");
        

    var Superclass,
        tabComponentInit = function (tabList) {
            return tabList.map(function (tab) {
                var new_tab = {
                    id: tab.id || tab.name,
                    name: tab.name,
                    name_es: tab.name_es || tab.name,
                    viewController: (tab.viewController instanceof ViewController ) ? tab.viewController : new tab.viewController(tab.args)
                };

                if (tab.live && options.isLive) {
                    liveSpot = index;
                    tab.id = state === "Wrapup" ? 'wrap' : 'game';
                }

                return new_tab;
            }).filter(Boolean);
        },

        tabComponentListBuilder = function (_options) {
            var panelList = [],
                options = extend({}, _options),
                liveSpot,
                lang = LocalizationUtil.lang,
                
             panelList = _options.tabs;
          
            options.nav = 'tabs';
            options.views = panelList.map(function (tab, index) {
                var new_tab = {
                    id: tab.id || tab.name,
                    name: lang ? tab['name_' + lang] || tab.name : tab.name
                };

                if (tab.live) {
                    if (options.isLive) {
                        liveSpot = index;
                        // new_tab.id= state==="Wrapup" ? 'wrap' : state==='Pregame' ? 'preview' : 'game';
                    } else {
                        new_tab = null;
                    }
                }

                if (new_tab) {
                    new_tab.viewController = new tab.viewController(tab.args)
                }
                return new_tab;
            }).filter(Boolean);
            if (liveSpot !== undefined) {
                options.liveSpot = liveSpot;
            }
            if (options.isLive && !options.allowFullscreen && liveSpot !== undefined) {
                options.views[liveSpot].viewController.allowControls = false;
            }
            return options;
        };
    // Constructor
    function GamePanelStateViewController(options) {
        // Call super constructor
        Superclass.constructor.call(this);
        this.options = options;
        this.gameView = null;
        this.currentState = null;
        this.fullscreenCard = false;
    }

    ViewController.spawn(GamePanelStateViewController).define({
        viewWillAppear: function () {
            var that = this;
            Superclass.viewWillAppear.call(this);
            this.onStateChange = function(data) {
                that.options.tabs = data.tabs
                that.setStateView(data.state || "Pregame");
            };
            MessageService.on(UpdateEvents.UPDATE_PANELTABS, this.onStateChange);
            // MessageService.on.call(this,HashEvents.GAME_STATE_CHANGED,this.getStateView);
            this.getStateView();
        },
        draw: function () {
            Superclass.draw.call(this);
            this.setClassName("GamePanelStateViewController");
        },

        getStateView: function () {
            var that = this;
            this.showOverlay();
            
            MessageService.publish(UpdateEvents.REQUEST_PANELTABS);              
        },
        setStateView: function (state, forced) {
            var view,
                that = this,
                newopts;

            forced = forced || false;
            //console.log('GPV',state,forced,this.parentViewController)
            if (state && (state !== this.currentState || !this.gameView) || forced === true) {

                newopts = tabComponentListBuilder(this.options);
                this.showOverlay();
                this.killGameView();
                this.setClassName(state, this.currentState);

                this.currentState = state;
                view = this.gameView = new GamePanelViewController(newopts);
                view.setFullscreenCard(this.fullscreenCard);
                view.parentViewController = this;
                view.viewWillAppear();
                // console.log(this.start)
                this.childViewControllers = [view];
                //view.getStatePanel(state);

                this.getView().appendChild(view.getView());
                view.viewDidAppear();
                renderComplete(function () {
                    //that.checkHeight();
                    that.setAvailableHeight();
                });

            }
            this.hideOverlay();
        },
        viewWillDisappear: function () {
            Superclass.viewWillDisappear.call(this);
            if (this.onStateChange) {
                MessageService.off(UpdateEvents.UPDATE_PANELTABS,this.onStateChange);
             }

            this.killGameView();
            // this.currentState=null;
            this.onStateChange = null;
        },
        killGameView: function () {
            if (this.gameView) {
                this.gameView.viewWillDisappear();
                dom.removeNode(this.getView(), this.gameView.getView());
                this.gameView.viewDidDisappear();
                this.gameView.parentViewController = null;
                this.childViewControllers = [];
                this.gameView.viewDidUnload();
                this.gameView = null;
            }

        },
        setFullscreenCard: function (val) {
            this.fullscreenCard = val;
            if (this.childViewControllers.length) {
                this.childViewControllers[0].setFullscreenCard(val);
            }
        }
    });
    Superclass = GamePanelStateViewController.superclass;
    return GamePanelStateViewController;
});

